<template>
    <LayoutDefault variant="white">
        <TransitionFadeOut>
            <AtomFullPageLoader variant="white" v-if="loaders['GET_FOLDER']" />
        </TransitionFadeOut>

        <div v-if="folder" class="overflow-hidden">
            <OrganismFolderHero />
            <div class="container max-w-[1200px] mx-auto">
                <OrganismFolderAbout />
                <OrganismFolderSubFolder
                    v-for="subFolder in folder.sub_folders"
                    :key="`sub-folder-${subFolder.id}`"
                    :sub-folder="subFolder"
                />
            </div>
        </div>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault.vue";
import OrganismFolderHero from "../components/folder/organisms/OrganismFolderHero.vue";
import TransitionFadeOut from "../transitions/TransitionFadeOut.vue";
import AtomFullPageLoader from "../components/global/atoms/AtomFullPageLoader.vue";
import {mapActions, mapState} from "vuex";
import OrganismFolderAbout from "../components/folder/organisms/OrganismFolderAbout.vue";
import OrganismFolderSubFolder from "../components/folder/organisms/OrganismFolderSubfolder.vue";

export default {
    name: "PageFolder",
    components: {
        OrganismFolderSubFolder,
        OrganismFolderAbout,
        AtomFullPageLoader, TransitionFadeOut,
        OrganismFolderHero,
        LayoutDefault
    },
    props: {
        id: {
            required: true
        }
    },
    created() {
        this.getFolder(this.id);
    },
    methods: {
        ...mapActions('folder', ['getFolder'])
    },
    computed: {
        ...mapState('ui', {
            loaders: 'loaders',
        }),
        ...mapState({
            folder: state => state.folder.folder
        })
    }
}
</script>
